import { PATH } from 'constants/RoutesConstants';
import { ENTITY_TYPE } from 'modules/app/constants';
import { actionTypeFormatter } from 'modules/sockets/actionTypes';
import { SOCKET_ACTION, SOCKET_TOPIC } from 'modules/sockets/constants';
import { subscribeOnPage } from 'modules/sockets/utils.middleware';

import { getSocketSubscription } from '../selectors/details';

export const WS_CAMPAIGN_STATS_UPDATE = actionTypeFormatter(
  SOCKET_TOPIC.DETAILS,
  ENTITY_TYPE.CAMPAIGN,
  SOCKET_ACTION.CAMPAIGN_STATS_UPDATE
);

export const WS_CAMPAIGN_BULK_INTERVENTIONS_CREATED_COMPLETED = actionTypeFormatter(
  SOCKET_TOPIC.DETAILS,
  ENTITY_TYPE.CAMPAIGN,
  SOCKET_ACTION.CAMPAIGN_BULK_INTERVENTIONS_CREATED_COMPLETED
);

export const WS_CAMPAIGN_BULK_FOLLOW_COMPLETED = actionTypeFormatter(
  SOCKET_TOPIC.DETAILS,
  ENTITY_TYPE.CAMPAIGN,
  SOCKET_ACTION.CAMPAIGN_BULK_FOLLOW_COMPLETED
);

export default function* campaignSocket() {
  // Initialize socket on page
  yield subscribeOnPage([PATH.CAMPAIGNS_DETAILS], SOCKET_TOPIC.DETAILS, getSocketSubscription);
}
